import React from 'react';
import { evalBinding } from '../../lib/bindings';

export default function KeyValueBlock({ block, data }: any) {
  const items = block.items || [];
  // opt-in/out “card” chrome (you already use card:false in the dark band)
  const useCard = block.card !== false;
  const cls = `key-value${useCard ? ' card' : ''}${block.className ? ' ' + block.className : ''}`;

  return (
    <div className={cls} style={block.style || undefined}>
      {items.map((it: any, i: number) => {
        const val = evalBinding(it.value, data);
        return (
          <div key={i} className="kv-row">
            {/* optional icon */}
            {it.icon && (
              <img
                className="kv-icon"
                src={it.icon}
                alt=""
                aria-hidden="true"
              />
            )}
            <div className="kv-label">{it.label}</div>
            <div className="kv-value">{val}</div>
          </div>
        );
      })}
    </div>
  );
}
